import React, { CSSProperties, FC, useContext, useEffect, useState } from "react";
import Layout from "../../components/Layout";
import SEO from "../../components/SEO";
import NavContext, {
  NavProvider,
} from "../../components/Layout/Nav/NavProvider";
import { t } from "i18next";
import { getCurrentLanguage } from "../../i18n";
import SectionHeader from "../../components/SectionHeader";
import Slider from "../../components/Slider";
import HomeSliderContact from "../../components/HomeSliderContact";
import "./index.scss";
import twitch from "../../images/SocialNetwork/twitch.svg";
import tiktok from "../../images/SocialNetwork/tik-tok.svg";
import youtube from "../../images/SocialNetwork/youtube.svg";
import instagram from "../../images/SocialNetwork/instagram.svg";
import meta from "../../images/SocialNetwork/meta.svg";
import Button from "../../components/Button";
import { getSectionSlug, YouplanetSections } from "../../constants/general";

const NetworkPage: FC = () => {
  const page: any = {};
  page.i18n_lang = getCurrentLanguage();

  const { isMobile } = useContext(NavContext);
  const [isMobileActive, setIsMobileActive] = useState<boolean>(false);
  const slug = typeof window !== "undefined" ? window.location.pathname : "";

  const icons = [
    { src: twitch, isSquare: false },
    { src: tiktok, isSquare: false },
    { src: youtube, isSquare: false },
    { src: instagram, isSquare: true },
    { src: meta, isSquare: false },
  ];

  const textList = [
    "firstLine",
    "secondLine",
    "thirdLine",
    "fourthLine",
    "fifthLine",
  ];

  const titleDelayStyle = (delay: number) => {
    return { animationDelay: `${delay}s` } as CSSProperties;
  };

  const buildText = (keyText: string, index: number) => {
    const splittedText = t(`network.text.${keyText}`).split("{{icon}}");

    const secondaryDelay = 0.15;
    const delay = index > 0 ? index * 0.3 : secondaryDelay;

    return (
      <div className="network__container" key={`${keyText}-${index}`}>
        <h2
          className={`network__paragraph ${
            index % 2 ? "is-strong" : ""
          } is-animated has-${index}-space`}
          style={titleDelayStyle(delay)}
          title={splittedText.join("")}
        >
          {splittedText[0]}
          {splittedText.length > 1 && (
            <>
              <span
                className={`network__cover ${
                  icons[index].isSquare ? "is-square" : ""
                }`}
              >
                <img
                  src={icons[index].src}
                  className={`network__icon ${
                    icons[index].isSquare ? "is-square" : ""
                  }`}
                  alt=""
                />
              </span>
              {splittedText[1]}
            </>
          )}
        </h2>
        <div
          className="network__separator is-active"
          style={titleDelayStyle(delay + secondaryDelay)}
        />
      </div>
    );
  };

  useEffect(() => {
    setIsMobileActive(isMobile());
  }, [isMobile])

  function pageContent() {
    const elements: JSX.Element[] = [
      <div className="network__content scrollable">
        <div className="network__row">
          <div className="network__separator is-active" />
          {textList.map((keyText, i) => buildText(keyText, i))}
          <div
            className="network__button is-animated"
            style={titleDelayStyle(textList.length * 0.3)}
          >
            <Button
              solid
              uppercase
              isLink
              href={getSectionSlug(YouplanetSections.Contact, getCurrentLanguage())}
            >
              {t("network.contact")}
            </Button>
          </div>
        </div>
      </div>,
      <HomeSliderContact />,
    ];
    return elements.map((element, index) => (
      <span key={index}>
        {element}
      </span>
    ));
  }

  return (
    <NavProvider>
      <Layout>
        <SEO
          title={t("network.pageTitle")}
          description={t("network.pageDescription")}
          lang={page.i18n_lang}
          slug={slug}
        />
        <SectionHeader h1={t("network.title")} inView={true} />
        <section className="network">
          {isMobileActive ? pageContent() : <Slider>{pageContent()}</Slider>}
        </section>
      </Layout>
    </NavProvider>
  );
};
export default NetworkPage;
